<!--
 * @Author: zyy
 * @Date: 2022-10-08 11:38:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-12 12:28:52
 * @Description: default
-->

<template>
    <div>
        <div v-show="step === 1">
            <a-spin tip="加载中..." :spinning="table.loading">
                <a-table :columns="columns" :data-source="table.data" rowKey="id" :pagination="table.page"
                    :row-selection="rowSelection" @change="handlePageChange">
                    <span slot="goods" slot-scope="data">
                        <span><img :src="data.image" height="30" width="30" style="margin-right:10px"></span>
                        <span>{{ data.title }}</span>
                    </span>
                </a-table>
            </a-spin>
            <a-row>
                <a-col style="text-align:center">
                    <a-button type="primary" @click="nextStep">下一步</a-button>
                </a-col>
            </a-row>
        </div>
        <div v-show="step === 2">
            <a-row>
                <a-col>
                    <div style="padding:10px;background-color: rgba(243,243,243,0.46);border-radius: 5px;">
                        <img :src="selectedGoods.image" alt="" width="40" height="40" style="margin-right:10px">
                        <span>{{ selectedGoods.title }}</span>
                    </div>
                </a-col>
            </a-row>
            <a-row>
                <a-col>
                    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 2 }"
                        :wrapper-col="{ span: 14 }">
                        <div style="margin:20px">
                            <div class="line-height-30">
                                <span>库存:</span><span class="ml-10">{{ selectedGoods.stock }}</span>
                            </div>
                            <div class="line-height-30">
                                <span>价格:</span><span class="ml-10">{{ selectedGoods.price }}</span>
                            </div>
                            <div class="line-height-30">
                                <span>活动销量:</span><span class="ml-10">{{ form.sales }}</span>
                            </div>
                        </div>
                        <a-form-model-item label="活动库存" prop="stock">
                            <a-input-number placeholder="请输入活动库存" v-model="form.stock[0]"
                                :max="Number(selectedGoods.stock)"></a-input-number>
                        </a-form-model-item>
                        <a-form-model-item label="兑换积分" prop="score">
                            <a-input placeholder="请输入兑换积分" type="number" v-model="form.score[0]"></a-input>
                        </a-form-model-item>
                        <a-form-model-item label="兑换价格" prop="price">
                            <a-input placeholder="请输入兑换价格" type="number" v-model="form.price[0]"></a-input>
                        </a-form-model-item>
                        <div style="text-align: center;">
                            <a-button style="margin-right:20px" @click="step = 1" v-show="!integralData.id">上一步</a-button>
                            <a-button type="primary" @click="submit">提交</a-button>
                        </div>
                    </a-form-model>
                </a-col>
            </a-row>

        </div>
    </div>
</template>
<script>
import GoodsListService from "@/io/goods_list.js";
import integralGoodsService from "@/io/goods/integralGoods.js";

export default {
    props: {
        integralData: {
            default: {}
        }
    },
    data() {
        let self = this;
        return {
            step: 1,
            form: {
                sales: 0,
                stock: [],
                score: [],
                price: [],
                goods_id: [],
                sku_price_id: [],
                status: 'up'

            },
            rules: {
                stock: [{ required: true, message: '请输入活动库存' }],
                price: [{ required: true, message: '请输入活动库存' }],
                score: [{ required: true, message: '请输入活动库存' }],
            },
            columns: [
                {
                    title: "id",
                    dataIndex: "id",
                },
                {
                    title: "商品信息",
                    key: "goods",
                    scopedSlots: { customRender: "goods" },
                },
                {
                    title: "库存",
                    dataIndex: "stock",
                    key: "stock",
                },

            ],
            table: {
                loading: false,
                data: [],
                page: {
                    total: 10,
                    current: 1,
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    showTotal() {
                        return `共${self.table.page.total}条`;
                    },
                },
            },
            selectedGoods: {}
        }
    },
    mounted() {
        if (!this.integralData.id) {
            this.getGoodsList()
            this.step = 1
        } else {
            this.step = 2
            const { id, sales, stock, score, price } = this.integralData
            this.selectedGoods = this.integralData
            this.form = {
                sales: sales,
                stock: [stock],
                score: [score],
                price: [price],
                goods_id: [id],
                sku_price_id: [id],
                status: 'up'
            }
        }

    },
    computed: {
        rowSelection() {
            return {
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectedGoods = selectedRows[0]
                },
                type: 'radio'
            };
        },
    },
    methods: {
        nextStep() {
            if (this.selectedGoods.id) {
                this.step = 2
                this.form.goods_id[0] = this.selectedGoods.id
            } else {
                this.$message.error('请选择商品')
            }
        },
        getDetail() {

        },
        getGoodsList() {
            let { current, pageSize } = this.table.page
            this.table.loading = true
            GoodsListService.list({
                page: current,
                limit: pageSize
            }).then(res => {
                this.table.data = res.data.rows
                this.table.page.total = res.data.total
            }).finally(() => this.table.loading = false)
        },

        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    if (this.integralData.id) {
                        integralGoodsService.edit(this.form).then(res => {
                            if (res.code == 1) {
                                this.$emit('submit')
                                this.$message.success(res.msg)
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    } else {
                        integralGoodsService.add(this.form).then(res => {
                            if (res.code == 1) {
                                this.$emit('submit')
                                this.$message.success(res.msg)
                            } else {
                                this.$message.error(res.msg)
                            }

                        })
                    }

                }
            });
        },
        handlePageChange(page) {
            this.table.page.current = page.current;
            this.table.page.pageSize = page.pageSize;
            this.getList();
        },
    }
}
</script>
<style lang="less" scoped>
.line-height-30 {
    line-height: 30px;
}

.ml-10 {
    margin-left: 10px;
}
</style>